import { indexItems, updatesItems, commentsItems } from '@/mocks/homeData';

export function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-2">热门专题</h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-12">八大核心频道，总有一个是你的菜</p>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {indexItems.map((item) => (
            <a
              key={item.id}
              href="#carousel"
              className="group bg-background-50 border border-background-200/70 rounded-lg p-5 hover:border-primary-300 transition-colors cursor-pointer"
            >
              <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center mb-3 group-hover:bg-primary-200 transition-colors">
                <i className={`${item.icon} text-lg text-primary-600`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-800 mb-1.5">{item.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed mb-3 line-clamp-2">{item.description}</p>
              <span className="text-xs text-primary-500 font-medium">{item.count}条内容</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

export function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[960px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-2">实时快讯</h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-12">51黑料不打烊 · 24小时滚动更新</p>
        <div className="relative pl-8 border-l-2 border-primary-200 ml-4">
          {updatesItems.map((item, idx) => (
            <div key={item.id} className={`relative pb-8 ${idx === updatesItems.length - 1 ? 'pb-0' : ''}`}>
              <div className="absolute -left-[calc(2rem+5px)] top-0 w-3 h-3 rounded-full bg-primary-500 border-2 border-background-50"></div>
              <div className="bg-background-50 border border-background-200/70 rounded-lg p-4">
                <div className="flex items-center gap-3 mb-1.5">
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{item.time}</span>
                  {item.tag && (
                    <span className={`text-[10px] font-bold px-1.5 py-0.5 rounded-full whitespace-nowrap ${
                      item.tag === '爆' ? 'bg-primary-500 text-background-50' :
                      item.tag === '热' ? 'bg-accent-500 text-background-50' :
                      'bg-secondary-500 text-background-50'
                    }`}>
                      {item.tag}
                    </span>
                  )}
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed">{item.content}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="text-center mt-8">
          <a href="#index" className="inline-flex items-center gap-1.5 text-sm text-primary-500 hover:text-primary-600 font-medium cursor-pointer">
            查看更多快讯
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}

export function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[960px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-2">吃瓜热评</h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-12">百万吃瓜群众的真实声音</p>
        <div className="space-y-4">
          {commentsItems.map((item) => (
            <div key={item.id} className="bg-background-50 border border-background-200/70 rounded-lg p-5">
              <div className="flex items-start gap-3">
                <div className="flex-shrink-0 w-10 h-10 rounded-full bg-background-200 overflow-hidden">
                  <img src={item.avatar} alt={item.nickname} className="w-full h-full object-cover" loading="lazy" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1.5">
                    <span className="text-sm font-semibold text-foreground-800">{item.nickname}</span>
                    {item.tag && (
                      <span className="text-[10px] font-bold text-primary-600 bg-primary-100 px-1.5 py-0.5 rounded-full whitespace-nowrap">{item.tag}</span>
                    )}
                    <span className="text-xs text-foreground-400 ml-auto whitespace-nowrap">{item.time}</span>
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-3">{item.content}</p>
                  <div className="flex items-center gap-4 text-xs text-foreground-400">
                    <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                      <i className="ri-thumb-up-line"></i>
                      {item.likes.toLocaleString()}
                    </span>
                    <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                      <i className="ri-chat-1-line"></i>
                      回复
                    </span>
                    <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                      <i className="ri-share-line"></i>
                      分享
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}